import React from 'react';
import PropTypes from 'prop-types';
import './loading.scss';
const Loading = ({ language = { name: 'en', direction: 'ltr' } }) => {
  return (
    <div
      className={`w-100 d-flex align-items-center justify-content-center position-relative loading-container direction-${language.direction}`}
    >
      <span className="d-flex align-items-center justify-content-center rotating-image">
        <img
          width={'100%'}
          height={'100%'}
          src={require('../../../content/images/loading/rotate.png')}
          alt="loading"
        />
      </span>
      <span className="position-absolute static-image">
        <img
          width={'100%'}
          height={'100%'}
          src={require('../../../content/images/loading/airplane.png')}
          alt="loading"
        />
      </span>
    </div>
  );
};

Loading.propTypes = {
  language: PropTypes.object,
};

export default Loading;
